import { axiosEjFetch } from "./axiosEjHelpers";
import type { AiBudgetPriceDto } from "./magicAiPaymentService";

export interface AvailableExtraDto {
  productId: string;
  netAmount: number;
  grossAmount: number;
  vat: number;
  currencyCode: string;
  isAlreadyPurchased: boolean;
}

export interface GetAvailableExtrasResponse {
  success: boolean;
  extras: AvailableExtraDto[];
  aiBudgetPrices?: AiBudgetPriceDto[];
  validationErrors?: string[];
}

export interface PurchaseExtraItem {
  productId: string;
  quantity: number;
  metaDataInJson?: string | null;
}

export interface PurchaseExtrasRequest {
  extras: PurchaseExtraItem[];
  aiBudgetPriceId?: string;
  successUrl: string;
  cancelUrl: string;
}

export interface PurchaseExtrasResponse {
  success: boolean;
  gatewayUrl?: string;
  validationErrors?: string[];
}

export async function getAvailableExtras(
  reservationId: string
): Promise<GetAvailableExtrasResponse> {
  return axiosEjFetch.safeGet<
    undefined,
    undefined,
    GetAvailableExtrasResponse
  >(`/api/reservation/${reservationId}/availableExtras`);
}

export async function purchaseExtras(
  reservationId: string,
  request: PurchaseExtrasRequest
): Promise<PurchaseExtrasResponse> {
  const response = await axiosEjFetch.safePost<
    PurchaseExtrasRequest,
    undefined,
    undefined,
    PurchaseExtrasResponse
  >(`/api/reservation/${reservationId}/purchaseExtras`, request);
  return response.data;
}
